import React, { useState } from 'react';
import "./SalesPartners.css"
import { User, Mail, Phone, Send, Square } from "lucide-react";
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";
import ContactImg from "../images/contact-us.png";
import ContactMap from '../images/Map-gif.gif';
// import ContactMap from '../images/contact-map.png';
import SubscribeIcon from "../images/explore.png"; // Adjust the path to your circular icon image

function SalesPartners() {
    //
    const [showFormPopup, setShowFormPopup] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [showThankYouPopup, setShowThankYouPopup] = useState(false);


    const handleReachOut = (context) => {
        setShowFormPopup(true);
        setFormSubmitted(false); // Reset form submission when opening popup
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // You can add form validation or API call here
        setFormSubmitted(true);
    };


    // 

    // Form PHP
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        // Optional: basic validation
        if (!formData.fullName || !formData.email || !formData.phone || !formData.message) {
            setResponseMessage("Please fill in all fields.");
            setLoading(false);
            return;
        }

        const formBody = new URLSearchParams(formData).toString();

        try {
            const response = await fetch("https://peracause.com/contact-form-premier-pumps.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formBody,
            });

            const result = await response.json();

            if (result.status === "success") {
                setResponseMessage("Message sent successfully! ✅");
                setFormData({
                    fullName: "",
                    email: "",
                    phone: "",
                    message: "",
                });
                setShowFormPopup(false); // close form
                setShowThankYouPopup(true); // open thank-you popup
            } else {
                setResponseMessage("Error: " + result.message);
            }
        } catch (error) {
            setResponseMessage("Error sending message. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    // Form PHP

    // newsletter form 
    const [newsletterEmail, setNewsletterEmail] = useState("");
    const [newsletterStatus, setNewsletterStatus] = useState("");

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        setNewsletterStatus("Submitting...");

        try {
            const formData = new FormData();
            formData.append("email", newsletterEmail);

            const response = await fetch("https://peracause.com/newsletter-premier-pumps.php", {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                setNewsletterStatus("✅ Successfully subscribed!");
                setNewsletterEmail("");
            } else {
                setNewsletterStatus("❌ Subscription failed. Please try again.");
            }
        } catch (error) {
            console.error("Newsletter Error:", error);
            setNewsletterStatus("⚠️ An error occurred. Please try again later.");
        }
    };

    // newsletter form 
    return (
        <div>
            <div>
                <section className="container-fluid my-5 position-relative">
                    {/* <div className="contact-connect card shadow-md p-3 position-fixed end-0 z-1">
                        <div className="d-flex flex-md-column flex-row align-items-center justify-content-between gap-3 text-center text-md-start ">
                            <h6 className=" text-dark fw-bold fs-sm-14 mb-0">Let’s Stay <br /> Connected!</h6>
                            <a
                                href="https://wa.me/+916309333412"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn whatsapp-color text-white d-flex align-items-center justify-content-center fs-sm-14"

                            >
                                <FaWhatsapp size={24} className="" />

                            </a>
                        </div>
                    </div> */}
                    <div className="container contact-hero p-lg-5 p-sm-">
                        <div className="row mb-3">
                            <div className="col-lg-6 p-3 my-2">
                                <img className="img-fluid" src={ContactImg} alt="" />
                            </div>
                            <div className="col-lg-6 d-flex flex-column justify-content-center my-2">
                                <h2 className="fs-1 text-blue">Sales Partners</h2>
                                <p className="fs-5">PREMIER is looking for channel partners, distributors and sales representatives across the world.</p>
                                <p className="fs-5">Contact us to know more on how to become a sales partner for the fastest growing Liquid Ring Vacuum Pump company.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 px-5">
                                <h2 className='text-blue'>Let’s get in touch!</h2>
                                {/* <p>Got questions about the Landing Page UI Kit? Our team is here to help. Contact us for quick and
                friendly support.</p> */}
                            </div>
                            <div className="col-lg-6 px-5 my-3">
                                <div className="d-flex justify-content-center flex-column my-5 gap-4">
                                    <div className="contact-link d-flex align-items-center gap-3">
                                        <i className="fa-solid fa-phone-volume fs-4 text-blue"></i>
                                        <a href="tel:+91 63093 33412" className="fs-5 text-decoration-none text-dark">+91 63093 33412</a>
                                    </div>

                                    <div className="contact-link d-flex align-items-center gap-3">
                                        <i className="fa-regular fa-envelope fs-4 text-blue"></i>
                                        <a href="maillto:support@premierpumps.net"
                                            className="fs-5 text-decoration-none text-dark">support@premierpumps.net</a>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center flex-column">
                                    <h4 className="fw-bold ">Connect with us</h4>
                                    <a href="https://www.linkedin.com/company/premier-pumps/" target="_blank" rel="noopener noreferrer">
                                        <FaLinkedin className="linkedin-icon fs-1" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6 my-3">
                                <div className="form-container">
                                    {!formSubmitted ? (
                                        <form onSubmit={handleSubmit}>
                                            <div className="input-group flex-column">

                                                {/* Full Name */}
                                                <label className="fw-medium">
                                                    Name <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-wrapper rounded-20 my-1 p-3">
                                                    <div className="d-flex align-items-center">
                                                        <User size={20} className="input-icon text-blue me-2" />
                                                        <input
                                                            name="fullName"
                                                            type="text"
                                                            placeholder="Enter your name"
                                                            className="form-control border-start rounded-0 ps-2"
                                                            required
                                                            value={formData.fullName}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Email */}
                                                <label className="fw-medium">
                                                    Email <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-wrapper rounded-20 my-1 p-3">
                                                    <div className="d-flex align-items-center">
                                                        <Mail size={20} className="input-icon text-blue me-2" />
                                                        <input
                                                            name="email"
                                                            type="email"
                                                            placeholder="Enter your email"
                                                            className="form-control border-start rounded-0 ps-2"
                                                            required
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Phone */}
                                                <label className="fw-medium">Phone</label>
                                                <div className="input-wrapper rounded-20 my-1 p-3">
                                                    <div className="d-flex align-items-center">
                                                        <Phone size={20} className="input-icon text-blue me-2" />
                                                        <input
                                                            name="phone"
                                                            type="tel"
                                                            placeholder="Enter your phone number"
                                                            className="form-control border-start rounded-0 ps-2"
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = [
                                                                    "Backspace", "ArrowLeft", "ArrowRight", "Delete",
                                                                    "Tab", "Home", "End", "+", "-", "(", ")", " "
                                                                ];
                                                                const isNumber = /^[0-9]$/.test(e.key);
                                                                const isAllowed = allowedKeys.includes(e.key);
                                                                if (!isNumber && !isAllowed) e.preventDefault();
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Message */}
                                                <label className="fw-medium mt-3">Message</label>
                                                <div className="input-wrapper rounded-20 my-1 p-3">
                                                    <textarea
                                                        name="message"
                                                        placeholder="Your Message"
                                                        rows="4"
                                                        className="form-control rounded-0 ps-2"
                                                        required
                                                        value={formData.message}
                                                        onChange={handleChange}
                                                    />
                                                </div>

                                                {/* Submit Button */}
                                                <div className="d-flex justify-content-center">
                                                    <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                                                        {loading ? "Sending..." : "Submit"}
                                                    </button>
                                                </div>
                                            </div>

                                            {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                                        </form>
                                    ) : (
                                        <div className="text-center p-4">
                                            <p>Thank you for reaching out! We'll get back to you soon.</p>
                                            <button
                                                className="btn btn-primary mt-3 px-4"
                                                onClick={() => {
                                                    setFormSubmitted(false);
                                                    setShowThankYouPopup(false);
                                                }}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* whatsapp  */}
                <div className="contact-connect card shadow-md p-3 position-fixed end-0 fixed-whatsapp">
                    <div className="d-flex flex-md-column flex-row align-items-center justify-content-between gap-3 text-center text-md-start ">
                        <h6 className=" text-dark fw-bold fs-12 mb-0">Let’s Stay <br /> Connected!</h6>
                        <a
                            href="https://wa.me/+916309333412"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn whatsapp-color text-white d-flex align-items-center justify-content-center fs-12"

                        >
                            <FaWhatsapp size={24} className="" />

                        </a>
                    </div>
                </div>
                {/* whatsapp  */}

                <section className="">
                    <div className=" ">
                        <img src={ContactMap} alt="" className="img-fluid" />
                    </div>
                </section>

                {/* Explore Starts */}
                {/* // Subscribe Newsletter Section */}
                <div className="subscribe-newsletter-section my-md-5 my-0">
                    <div className="container py-3">
                        <div className="subscribe-inner">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-lg-2 col-md-3 col-sm-12 text-center text-md-start mb-3 mb-md-0">
                                    <img
                                        src={SubscribeIcon}
                                        alt="Subscribe Icon"
                                        className="subscribe-icon img-fluid floating"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-9 col-sm-12">
                                    <div className="subscribe-content">
                                        <h3 className="subscribe-heading mb-3 fw-bold text-md-start text-center">
                                            Subscribe Newsletter
                                        </h3>
                                        <form onSubmit={handleNewsletterSubmit}>
                                            <div className="d-flex align-items-center justify-content-md-start justify-content-center position-relative">
                                                <input
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    value={newsletterEmail}
                                                    onChange={(e) => setNewsletterEmail(e.target.value)}
                                                    required
                                                    className="form-control subscribe-input me-2 py-4 bg-white border-0 rounded-15"
                                                />
                                                <button
                                                    type="submit"
                                                    className="btn subscribe-button py-2 fs-5 px-4 position-absolute end-0 me-3"
                                                >
                                                    <i className="fa-regular fa-envelope me-md-4 me-2 fs-4"></i>
                                                    Subscribe
                                                </button>
                                            </div>
                                        </form>
                                        {newsletterStatus && <p>{newsletterStatus}</p>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Explore Ends */}

                {/* thank you popup  */}

                {showThankYouPopup && (
                    <div className="thankyou-popup-overlay d-flex align-items-center justify-content-center" id="thankyou-popup-overlay">
                        <div className="thankyou-popup-box position-relative" id="thankyou-popup-box">
                            <div className="thankyou-popup-body text-center d-flex align-items-center justify-content-center flex-column">
                                <h5 className="mb-3 fw-bold text-blue fs-3">Thank you for reaching out to us.</h5>
                                <p> You can also contact PREMIER at <a href='mailto:support@premierpumps.net' >support@premierpumps.net</a></p>
                                <button
                                    className="btn btn-primary mt-3 px-4"
                                    onClick={() => setShowThankYouPopup(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}


                {/* thank you popup  */}

                {/* <PAChart /> */}
            </div>
        </div>
    )
}

export default SalesPartners